export default __webpack_public_path__ + "static/media/budget-setting.1e92322d.png";